import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class InstallerButtonsBaseComponent extends BaseComponent {
  public text: string = "InstallerButtons";

  constructor(userService: UserService) {
    super(userService);
  }
}
